import React from 'react';
import { gql } from '@apollo/client';
import EmailLink from '../../../components/EmailLink';
import { ContactListItemFragment } from '../../../generated/graphql';
import TableCell from '../../../components/TableCell';
import Text from '../../../components/Text';
import { ListItemComponent } from '../../../types';
import { useNavigate } from '../../../hooks/useNavigate';
import { noop } from '../../../helpers/utils';
import { Checkbox } from '@blueprintjs/core';

export type ContactListItemProps = {
  item: ContactListItemFragment;
  skeleton?: boolean;
} & ListItemComponent;

const ContactListItem = ({ item, skeleton, selected, onToggle }: ContactListItemProps) => {
  const navigate = useNavigate();
  return (
    <tr onClick={onToggle || skeleton ? noop : navigate(`/contacts/${item!.id}`)}>
      {onToggle && (
        <TableCell>
          <Checkbox inline disabled={skeleton} checked={selected} onChange={() => onToggle(item.id)} className="m-0" />
        </TableCell>
      )}
      <TableCell>
        <Text skeleton={skeleton}>{item.display_name}</Text>
      </TableCell>
      <TableCell>
        <EmailLink email={item.email} skeleton={skeleton} />
      </TableCell>
      <TableCell muted>
        <Text skeleton={skeleton}>{item.phone || item.mobile || '—'}</Text>
      </TableCell>
    </tr>
  );
};

ContactListItem.fragments = {
  contact: gql`
    fragment ContactListItem on Contact {
      id
      display_name
      email
      phone
      mobile
    }
  `,
};

export default ContactListItem;
